export const EditCardOnFileFormMessages = {
    SUCCESS_ALERT_MESSAGE: 'Credit card has been successfully updated.',
} as const;
